import { Controller } from "stimulus";

const INIT_DELAY = 200;

export default class extends Controller {
  static targets = ['field'];

  connect() {
    this.checkDelay = INIT_DELAY;
    this.checkForStripe = () => {
      if ('Stripe' in window) {
        this.fieldTarget.value = '1';

      } else if (Math.sqrt(this.checkDelay / INIT_DELAY) < 5) {
        this.checkDelay *= 2;
        this.scheduleCheck();

      }
    };

    this.scheduleCheck();
  }

  scheduleCheck() {
    setTimeout(this.checkForStripe, this.checkDelay);
  }
}
